<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="监督对象:" prop="name">
                        <el-input
                        v-model="queryParams.name"
                        placeholder="请输入监督对象"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="案由:" prop="anyou">
                        <el-input
                        v-model="queryParams.anyou"
                        placeholder="请输入案由"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="上传日期:" >
                        <el-date-picker size="small" clearable
                            v-model="queryParams.startDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                        至
                        <el-date-picker size="small" clearable
                            v-model="queryParams.endDate"
                            type="date"
                            placeholder="选择日期" value-format="yyyy-MM-dd">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="评查状态:">
                        <el-select v-model="queryParams.isPingce" placeholder="请选择评查状态" clearable size="small" style="width:120px;">
                            <el-option label="未评查"  value="0"></el-option>
                            <el-option label="已评查"  value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="chackcaseList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="监督对象" prop="dwmc" />
                    <el-table-column label="案由" prop="anyou" />
                    <el-table-column label="上传日期" align="center" prop="creattime" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.creattime">{{ getDate2(scope.row.creattime) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="立案日期" align="center" prop="lian_rq" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.lian_rq">{{ getDate2(scope.row.lian_rq) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结案日期" align="center" prop="jiean_rq" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.jiean_rq">{{ getDate2(scope.row.jiean_rq) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="监督员" align="center" prop="host_man" width="180"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.host_man">{{ scope.row.host_man}}、</span>
                            <span v-if="scope.row.cooperate_man">{{ scope.row.cooperate_man}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="处罚结果" align="center" prop="penalize"/>
                    <el-table-column label="评查状态" align="center" prop="isPingce" >
                        <template slot-scope="scope">
                            <span v-if="Number(scope.row.isPingce) > 0"><i style="width: 8px; height: 8px; display: inline-block; background: #1890ff; border-radius: 4px; margin-right: 5px;"></i>已评查</span>
                            <span v-else><i style="width: 8px; height: 8px; display: inline-block; background: #ff4a4a; border-radius: 4px; margin-right: 5px;"></i>未评查</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="评查得分" align="center" prop="fz" width="80" />
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleBack(scope.row)"
                        >退回</el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="anjuanPingce(scope.row)"
                        >{{Number(scope.row.isPingce) > 0? '评查详情':'案件评查'}}</el-button>
                        <el-button
                            size="small"
                            type="text"
                            @click="handleShow(scope.row)"
                        >查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <el-dialog title="智能评查" :visible.sync="open3" top="5vh" width="90%" append-to-body :close-on-click-modal="false" class="pcTk">
            <znpc :pcId="this.pcId" :ispc="this.ispc" :row="this.row" @handleCall="handleCall" />
        </el-dialog>
        <el-dialog title="智能评查" :visible.sync="open3Yz" top="5vh" width="90%" append-to-body :close-on-click-modal="false" class="pcTk">
            <znpcYz :pcId="this.pcId" :ispc="this.ispc" :row="this.row" @handleCall="handleCall" />
        </el-dialog>
        <el-dialog title="案卷详情" :visible.sync="open5" width="90%" top="2vh" append-to-body :close-on-click-modal="false" class="pcTk2">
            <ajxq :pcId="this.pcId" :states="1" />
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import Ajxq from '../ajpc/ajxq.vue'
import Znpc from '../ajpc/znpc.vue'
import ZnpcYz from '../ajpc/znpcYz.vue'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            cmid:'',
            dm:'',
            xianqu:'',
            queryParams:{
                name:'',
                anyou:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                isPingce:''
            },
            times:[],
            times2:[],
            total:0,
            chackcaseList:[],
            currentPage:1,
            pagesize:10,
            open3:false,
            pcId:'',
            row:{},
            open5:false,
            formR:{},
            ispc:0,
            pageshow:true,
            shiOptions:[],
            xianquOptions:[],
            open3Yz:false,
            baseUrl:''
        }
    },
    components: {
        Ajxq,
        Znpc,
        ZnpcYz
    },
    watch: {
        'queryParams.shi':{
            handler(val,oldVal){
                this.getxian(val)
            }
        }
    },
    props:{
        
    },
    filters: {
        ellipsis(value) {
            if (!value) return '';
            if (value.length > 20) {
                return value.slice(0, 20) + '...';
            }
            return value;
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.xianqu = user.xianqu
        this.baseUrl = user.baseUrl
        let yy = (new Date()).getFullYear()
        let mm1 = this.Time(new Date(new Date().getFullYear(),new Date().getMonth()-1,new Date().getDate()));
        let mm = (new Date()).getMonth()
        let dd = (new Date()).getDate()
        this.times = mm1
        this.times2 = yy+'-' + (mm+1) + '-' + dd
        this.$set(this.queryParams, 'startDate', this.times)
        this.$set(this.queryParams, 'endDate', this.times2)
        this.$forceUpdate()
        
        this.getList()
    },
    methods: {
        Time(now) {
            let year=new Date(now).getFullYear();
            let month=new Date(now).getMonth()+1;
            let date=new Date(now).getDate();
            if (month < 10) month = "0" + month;
            if (date < 10) date = "0" + date;
            return year+"-"+month+"-"+date
        },
        getxian(id){
            if(this.queryParams.shi){
                this.queryParams.xianqu = ''
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/getXianqu`,
                    data:{
                        id:id
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0 && res.data.data){
                        this.xianquOptions = res.data.data || []
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })
            }
        },
        getList(){
            this.queryParams.startDate = this.queryParams.startDate ? this.queryParams.startDate : this.times
            this.queryParams.endDate = this.queryParams.endDate ? this.queryParams.endDate : this.times2
            this.queryParams.xianqu = this.queryParams.shi ? this.queryParams.xianqu : ''
            let dm = this.queryParams.shi ? '' :this.dm
            this.chackcaseList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getAnjiannList`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmc: this.queryParams.name,
                    anyou:this.queryParams.anyou ,
                    cmid: this.cmid,
                    startDate:this.getDate(this.queryParams.startDate,'yyyy-MM-dd') ,
                    endDate: this.getDate(this.queryParams.endDate,'yyyy-MM-dd'),
                    states: 1,
                    dm: dm,
                    shi: this.queryParams.shi,
                    xianqu: this.queryParams.xianqu,
                    isPingce: this.queryParams.isPingce,
                    type: 1,
                    pageSize: this.queryParams.limit,
                    pageNum: this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.chackcaseList = response.data.data.list || []
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                this.$message.error('获取数据失败！');
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        resetQuery(){
            this.currentPage = 1
            this.queryParams = {
                name:'',
                anyou:'',
                startDate:'',
                endDate:'',
                page:1,
                limit:10,
                shi:'',
                xianqu:'',
                isPingce:''
            }
            this.getList()
        }, 
        handleShow(row){
            this.pcId = row.lsh
            this.row = row
            this.open5 = true
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        anjuanPingce(row){
            this.pcId = row.lsh
            this.row = row
            this.ispc = Number(row.isPingce)
            this.open3Yz = true
        },
        handleBack(row){
            this.$confirm("您是否确定要退回该案件。是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/setAnjianStates`,
                    data:{
                        pcId: row.lsh,
                        states:0
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0){
                        this.open = false
                        this.getList()
                    }else{
                        this.$message({
                            message: res.data.data+',提交失败，请重新操作！',
                            type: 'error'
                        });
                        setTimeout(()=>{
                            this.handleShow(lsh,0)
                        },1000)
                    }
                }).catch(error => {
                    this.$message.error(error);
                })
            })
        },
        handleCall(val){
            console.log(val)
            this.getList();
        }
    }
}
</script>


<style scoped>
.beizhu{color: #ff0000;}
.shibieW{width: 100%; overflow: hidden;}
.shibie{float: left; width: calc((100% - 30px) / 2 ); height: 70vh;}
.menus{ width: 200px;  height: calc(100% - 45px); float: left;}
.shibie >>> .el-scrollbar { width: 100%; height: 100%;}
.shibie >>> .el-scrollbar__bar.is-horizontal{opacity: 0;}
.shibie >>> .el-scrollbar__wrap { overflow-y: auto !important; overflow-x: hidden;}
.shibie >>> .el-scrollbar__view{min-height: 100%;}
.right .imgW >>> .el-scrollbar__view{ background: #eef3f9;}
.shibieW .right{float: right;}
.shibie h3{background: #fff; width:100%; color:#000; border-bottom: solid 1px #ddd; line-height: 36px; margin-bottom: 8px;}
.shibie ul{width: 180px;margin-right: 10px;}
.shibie ul li{line-height: 36px; width: 100%; overflow: hidden; white-space: normal; text-overflow: ellipsis; cursor: pointer;}
.shibie ul li.active{color:#1890ff;}
.imgW{width: calc(100% - 214px);  height: calc(100% - 45px);float: right;}
.imgW img{ width: 100%;}
.imgW h3{border-bottom: none; padding:10px 0;}
.imgW h3 span{ border-left: solid 4px #1890ff; line-height: 1; padding-left: 6px;display: block;}
.imgW >>> .el-form{ padding: 10px 0 10px 10px; width: calc(100% - 45px);}
.bigimg{width: 100%;}
.pcTk >>> .el-dialog{height: 90vh;}
.pcTk2 >>> .el-dialog{max-height: 96vh;}
.imgW >>> .el-textarea.is-disabled .el-textarea__inner ,.imgW >>> .el-input.is-disabled .el-input__inner { color: #606266;}
.shangchuan >>> .el-upload,.shangchuan >>> .el-upload-dragger {width:100%;}
.newTk >>> .el-loading-spinner .el-loading-text{color:#fff;}
.newTk >>> .el-loading-spinner .path{stroke: #FFF;}
.content >>> .el-date-editor.el-input,.content >>> .el-date-editor.el-input__inner{width:140px;}
</style>